import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { AgentTypeEnum } from '../enums/agent-type.enum';

/**
 * Create agent DTO
 */
export class CreateAgentDto {
  color?: string | null;
  type!: AgentTypeEnum;
  notes?: string | null;
  contact!: TenantContactDto;
  @TransformInt()
  agentCategoryId?: number | null;
  tags?: TagDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
